export default "__VITE_ASSET__DjJltTnf__"